import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import withRouter from '../../Common/withRouter';

const VerticalLayout = (props) => {
  const [adminStatus, setAdminStatus] = useState(null);

  useEffect(() => {
    const sessionData = JSON.parse(sessionStorage.getItem('user'));
    if (sessionData) {
      setAdminStatus(sessionData.admin_status);
    }
  }, []);

  return (
    <React.Fragment>
      <li className="list-group-item border-0 p-0" key="dashboard">
        <Link to="/dashboard" className='text-decoration-none'>
          <div className={`alert ${window.location.pathname === "/dashboard" ? "alert-primary" : "alert-light"}`} role="button">
            <div className='d-flex align-items-center'>
              <svg className='me-3' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="currentColor" d="M3 3h8v8H3V3Zm10 0h8v8h-8V3ZM3 13h8v8H3v-8Zm13 0h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3Z" />
              </svg>
              <span className='fw-semibold'>Dashboard</span>
            </div>
          </div>
        </Link>
      </li>
      <li className="list-group-item border-0 p-0" key="instruments">
        <Link to="/instruments" className='text-decoration-none'>
          <div className={`alert ${window.location.pathname === "/instruments" ? "alert-primary" : "alert-light"}`} role="button">
            <div className='d-flex align-items-center'>
              <svg className='me-3' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g transform="translate(24 0) scale(-1 1)">
                  <g fill="none" fillRule="evenodd">
                    <path d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z" />
                    <path fill="currentColor" d="M15.682 3.282a2 2 0 0 1 2.701-.116l.127.116l.707.708a2 2 0 0 1 .117 2.7l-.116.128l-.708.707a2.007 2.007 0 0 1-.194.17a2 2 0 0 1-.397 1.826l-.116.125l-.99.99A6.485 6.485 0 0 1 19 15.5c0 1.644-.61 3.145-1.616 4.29l-.194.21H20a1 1 0 0 1 .117 1.993L20 22H4a1 1 0 0 1-.117-1.993L4 20h8.5a4.5 4.5 0 0 0 3.075-7.786l-.18-.16l-3.249 3.25a2 2 0 0 1-2.7.116l-.128-.117l-2.121-2.121a2 2 0 0 1-.117-2.701l.117-.127l5.657-5.657a2 2 0 0 1 1.95-.513l.082-.1l.089-.094l.707-.708ZM6.49 13.89l2.12 2.121a1 1 0 1 1-1.413 1.415l-2.122-2.122A1 1 0 1 1 6.49 13.89Zm10.606-9.192l-.707.707l.707.707l.707-.707l-.707-.707Z" />
                  </g>
                </g>
              </svg>
              <span className='fw-semibold'>Instruments</span>
            </div>
          </div>
        </Link>
      </li>
      <li className="list-group-item border-0 p-0" key="projects">
        <Link to="/projects" className='text-decoration-none'>
          <div className={`alert ${window.location.pathname === "/projects" ? "alert-primary" : "alert-light"}`} role="button">
            <div className='d-flex align-items-center'>
              <svg className='me-3' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 1024 1024">
                <g transform="rotate(180 512 512)">
                  <path fill="currentColor" d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z" />
                </g>
              </svg>
              <span className='fw-semibold'>Projects</span>
            </div>
          </div>
        </Link>
      </li>
      <li className="list-group-item border-0 p-0" key="storage">
        <Link to="/storage" className='text-decoration-none'>
          <div className={`alert ${window.location.pathname === "/storage" ? "alert-primary" : "alert-light"}`} role="button">
            <div className='d-flex align-items-center'>
              <svg className='me-3' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g transform="rotate(180 12 12)">
                  <path fill="currentColor" d="M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z" />
                </g>
              </svg>
              <span className='fw-semibold'>Storage</span>
            </div>
          </div>
        </Link>
      </li>
      {adminStatus === 2 && (
        <>
          <li className="list-group-item border-0 p-0" key="userManagement">
            <Link to="/user-management" className='text-decoration-none'>
              <div className={`alert ${window.location.pathname === "/user-management" ? "alert-primary" : "alert-light"}`} role="button">
                <div className='d-flex align-items-center'>
                  <svg className='me-3' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M11 2v20c-5.52 0-10-4.48-10-10S5.48 2 11 2zm2 0v9h9c0-4.97-4.03-9-9-9zm0 11v9c4.97 0 9-4.03 9-9h-9z" />
                  </svg>
                  <span className='fw-semibold'>User Management</span>
                </div>
              </div>
            </Link>
          </li>
          <li className="list-group-item border-0 p-0" key="statistics">
            <Link to="/statistics" className='text-decoration-none'>
              <div className={`alert ${window.location.pathname === "/statistics" ? "alert-primary" : "alert-light"}`} role="button">
                <div className='d-flex align-items-center'>
                  <svg className='me-3' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17.93c-2.38.35-4.68-.47-6.36-2.15-1.68-1.68-2.5-3.98-2.15-6.36.35-2.38 1.57-4.53 3.54-6.25L12 10v8h8c0 1.1-.9 2-2 2h-5v-4.07z" />
                  </svg>
                  <span className='fw-semibold'>Statistics</span>
                </div>
              </div>
            </Link>
          </li>
          <li className="list-group-item border-0 p-0" key="processes">
            <Link to="/processes" className='text-decoration-none'>
              <div className={`alert ${window.location.pathname === "/processes" ? "alert-primary" : "alert-light"}`} role="button">
                <div className='d-flex align-items-center'>
                  <svg className='me-3' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17.93c-2.38.35-4.68-.47-6.36-2.15-1.68-1.68-2.5-3.98-2.15-6.36.35-2.38 1.57-4.53 3.54-6.25L12 10v8h8c0 1.1-.9 2-2 2h-5v-4.07z" />
                  </svg>
                  <span className='fw-semibold'>Processes</span>
                </div>
              </div>
            </Link>
          </li>
          <li className="list-group-item border-0 p-0" key="plantstandcount">
            <Link to="/plantstandcount" className='text-decoration-none'>
              <div className={`alert ${window.location.pathname === "/plantstandcount" ? "alert-primary" : "alert-light"}`} role="button">
                <div className='d-flex align-items-center'>
                  <svg className="me-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M5 21c6.5 0 11-4.5 11-11V3h-7C5.5 3 1 7.5 1 14c0 3.5 1.5 6 4 7Zm2-9c2-2 4-3 6-3-1 2-3 4-5 6-1 1-2 2-3 2l2-5Z" />
                  </svg>
                  <span className='fw-semibold'>Plant Stand Count</span>
                </div>
              </div>
            </Link>
          </li>
        </>
      )}
    </React.Fragment>
  );
};

export default withRouter(withTranslation()(VerticalLayout));
